import React from "react"
import { logTool, randomInt } from "@jsUtils"
import { ContentRow, GridLines } from "@shared"

import InvestorRow from "./InvestorRow"
import Styles from "./investors.module.scss"

const log = logTool(false)

const Investors = ({ teams, theme }) => {
  log("Investors:", { teams, theme })

  return (
    <ContentRow override="investorsContentRowIEOverride">
      <GridLines theme={theme} />
      {teams.map(i => (
        <InvestorRow styles={Styles} data={i} key={`${i.id}-${randomInt(0, Date.now())}`} />
      ))}
    </ContentRow>
  )
}

export default Investors
